module.exports = __webpack_public_path__ + "img/banner2.417460d1.png";